import script from "./RemoveBGPrivacy.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveBGPrivacy.vue?vue&type=script&setup=true&lang=js"

import "./RemoveBGPrivacy.vue?vue&type=style&index=0&id=07591691&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07591691"]])

export default __exports__